// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__PXBm9","link":"Sidebar_link__Y2087","active":"Sidebar_active__PduI1","navLinkTitle":"Sidebar_navLinkTitle__DQV00"};